import { Box, Button } from '@customink/pigment-react';
import { useProject } from '@customink/project-service-react-components';
import { SHIPPING_TYPES } from '@customink/project-service-types';

import ApplePayButton from './ApplePayButton';
import { useProceedToCheckout } from './hooks';
import Spinner from '../Spinner';

import { useHasMultipleDesigns } from '@/hooks/Design';
import { useInternalPreview } from '@/hooks/internalPreview';
import { useCheckoutEnabled, useCheckoutPending } from '@/hooks/Project';

const { INDIVIDUAL } = SHIPPING_TYPES;

export default function OrderSubmit() {
  const hasMultipleDesigns = useHasMultipleDesigns();
  const { data: project } = useProject();
  const isCheckoutValid = useCheckoutEnabled();
  const isCheckoutPending = useCheckoutPending();
  const proceedToCheckout = useProceedToCheckout();
  const isInternalPreview = useInternalPreview();

  const shippingType = project?.configuration?.shippingType;

  const showContinue = shippingType === INDIVIDUAL;
  const showLoading = isCheckoutPending;

  const unsupportedMultipleDesigns = hasMultipleDesigns && isInternalPreview;
  const disableCheckoutButton = !isCheckoutValid || unsupportedMultipleDesigns;

  const onProceedToCheckout = () => {
    window.dataLayer?.push({
      event: 'checkout_interaction',
      interaction_type: 'button_click',
      interaction_label: 'proceed_checkout',
      interaction_location: 'cart_summary',
    });
    proceedToCheckout();
  };

  let contents: string | JSX.Element = isInternalPreview
    ? 'Proceed to Internal Checkout'
    : 'Proceed to Checkout';

  if (showContinue) {
    contents = 'Continue';
  } else if (showLoading) {
    contents = <Spinner color="#a6a6a6" size={30} />;
  }

  return (
    <Box>
      <Button
        data-testid="order-submit"
        disabled={disableCheckoutButton}
        fullWidth
        onClick={onProceedToCheckout}
        size="large"
      >
        {contents}
      </Button>
      <ApplePayButton />
    </Box>
  );
}
